import { render, staticRenderFns } from "./BankDetailModal.vue?vue&type=template&id=3dbccd1a"
import script from "./BankDetailModal.vue?vue&type=script&lang=js"
export * from "./BankDetailModal.vue?vue&type=script&lang=js"
import style0 from "./BankDetailModal.vue?vue&type=style&index=0&id=3dbccd1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports